export function RedPackage2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <rect x="3" y="4" width="18" height="16" rx="3" fill="#E32521"></rect>
      <path d="M4 8l8 4 8-4" fill="#FFBA00"></path>
    </svg>
  );
}
